module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-module mb"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "focus-warp"
  }, [_c('div', {
    staticClass: "swipe-wrap",
    attrs: {
      "id": "qua-swiper"
    }
  }, [_c('div', {
    staticClass: "swipe",
    attrs: {
      "id": "qua-swiper-container"
    }
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.nums), function(item) {
    return _c('CarouselItem', {
      key: item.key
    }, [((item.key * 2 + 0) < _vm.jpsdGoodsAdvLeftList.length) ? _c('div', {
      staticClass: "qua-goods-1"
    }, [_c('router-link', {
      staticClass: "qua-goods-sm",
      attrs: {
        "to": _vm.jpsdGoodsAdvLeftList[item.key * 2 + 0].to,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.jpsdGoodsAdvLeftList[item.key * 2 + 0].atturl,
        "width": "175",
        "height": "500"
      }
    })])], 1) : _vm._e(), _vm._v(" "), ((item.key * 2 + 1) < _vm.jpsdGoodsAdvLeftList.length) ? _c('div', {
      staticClass: "qua-goods-2"
    }, [_c('router-link', {
      staticClass: "qua-goods-sm",
      attrs: {
        "to": _vm.jpsdGoodsAdvLeftList[item.key * 2 + 1].to,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.jpsdGoodsAdvLeftList[item.key * 2 + 1].atturl,
        "width": "350",
        "height": "500"
      }
    })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "qua-goods-3 clearfix"
    }, [((item.key * 6 + 0) < _vm.jpsdGoodsAdvRightList.length) ? _c('router-link', {
      staticClass: "qua-goods-sm",
      attrs: {
        "to": _vm.jpsdGoodsAdvRightList[item.key * 6 + 0].to,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "w170-250",
      attrs: {
        "src": _vm.jpsdGoodsAdvRightList[item.key * 6 + 0].atturl
      }
    })]) : _vm._e(), _vm._v(" "), ((item.key * 6 + 1) < _vm.jpsdGoodsAdvRightList.length) ? _c('router-link', {
      staticClass: "qua-goods-sm",
      attrs: {
        "to": _vm.jpsdGoodsAdvRightList[item.key * 6 + 1].to,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "w170-250",
      attrs: {
        "src": _vm.jpsdGoodsAdvRightList[item.key * 6 + 1].atturl
      }
    })]) : _vm._e(), _vm._v(" "), ((item.key * 6 + 2) < _vm.jpsdGoodsAdvRightList.length) ? _c('router-link', {
      staticClass: "qua-goods-sm",
      attrs: {
        "to": _vm.jpsdGoodsAdvRightList[item.key * 6 + 2].to,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "w170-250",
      attrs: {
        "src": _vm.jpsdGoodsAdvRightList[item.key * 6 + 2].atturl
      }
    })]) : _vm._e(), _vm._v(" "), ((item.key * 6 + 3) < _vm.jpsdGoodsAdvRightList.length) ? _c('router-link', {
      staticClass: "qua-goods-sm",
      attrs: {
        "to": _vm.jpsdGoodsAdvRightList[item.key * 6 + 3].to,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "w170-250",
      attrs: {
        "src": _vm.jpsdGoodsAdvRightList[item.key * 6 + 3].atturl
      }
    })]) : _vm._e(), _vm._v(" "), ((item.key * 6 + 4) < _vm.jpsdGoodsAdvRightList.length) ? _c('router-link', {
      staticClass: "qua-goods-sm",
      attrs: {
        "to": _vm.jpsdGoodsAdvRightList[item.key * 6 + 4].to,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "w170-250",
      attrs: {
        "src": _vm.jpsdGoodsAdvRightList[item.key * 6 + 4].atturl
      }
    })]) : _vm._e(), _vm._v(" "), ((item.key * 6 + 5) < _vm.jpsdGoodsAdvRightList.length) ? _c('router-link', {
      staticClass: "qua-goods-sm",
      attrs: {
        "to": _vm.jpsdGoodsAdvRightList[item.key * 6 + 5].to,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "w170-250",
      attrs: {
        "src": _vm.jpsdGoodsAdvRightList[item.key * 6 + 5].atturl
      }
    })]) : _vm._e()], 1)])
  }), 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "module-title"
  }, [_c('span', [_vm._v("精品速递")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c94dac2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal-shop/boutique-express.vue
// module id = 1644
// module chunks = 1